import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=273b5c03&scoped=true&"
import script from "./articles.vue?vue&type=script&lang=js&"
export * from "./articles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b5c03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273b5c03')) {
      api.createRecord('273b5c03', component.options)
    } else {
      api.reload('273b5c03', component.options)
    }
    module.hot.accept("./articles.vue?vue&type=template&id=273b5c03&scoped=true&", function () {
      api.rerender('273b5c03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/packageCode/components/articles.vue"
export default component.exports